import React from "react";
import { OrderDetailsData } from "../../../../../../../../services/Api/Public/types";
import { CostModifiersList } from "./components/CostModifiersList";
import { ItemsList } from "./components/ItemsList";
import OrderDetailsHeader from "./components/OrderDetailsHeader";
import { Summary } from "./components/Summary";

interface OrderDetailsSectionProps {
	details: OrderDetailsData;
}

export const OrderDetailsSection = ({
	details: { total_price, discount_price, items, source, order_at, tip, sub_total_price },
}: OrderDetailsSectionProps): JSX.Element => {
	return (
		<section className="order-details" data-testid="e-order-order-details-section">
			<OrderDetailsHeader orderAt={order_at} number={source?.number} />
			<ItemsList items={items} />
			<CostModifiersList discountPrice={discount_price} tip={tip} subTotalPrice={sub_total_price} />
			<Summary totalPrice={total_price} />
		</section>
	);
};
